// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__GIUg7","rightAdornment":"Header_rightAdornment__1BhWw"};